// extracted by mini-css-extract-plugin
module.exports = {"icon":"TrackYourIncome_icon__2rxZM","content":"TrackYourIncome_content__1Hsyo"};